import React from "react";

import styles from "./Fieldset.module.scss";

export const Fieldset = ({ disabled, ...props }) => (
  <fieldset
    {...props}
    disabled={disabled}
    className={`${styles.fieldset} ${disabled ? styles["fieldset-disabled"] : ""}`}
  />
);
